import React from 'react';

import { list as listStyle } from './style.module.css';

export interface SimpleListProps {
	items: Array<string>;
}

export const SimpleList = ({ items }: SimpleListProps) => {
	return (
		<ul className={listStyle}>
			{Array.isArray(items) &&
				items.map((item, idx) => (
					<li key={`${item}${idx}`}>
						<span>{item}</span>
					</li>
				))}
		</ul>
	);
};
